export default "__VITE_ASSET__CbYmURFI__"